// This is actually not good. We should use named zIndexes such as "zIndexModal", "zIndexNavBar".

const v = {
    zIndexMax: 2147483647,
    zIndexHighest: 90000, // Really high to get above z-indexes in external libraries
    zIndexHamburgerMenu: 1101, // hamburger menu
    zIndexLeftMenu: 1100, // left menu
    zIndexHigher: 400,
    zIndexHigh: 300, // The top nav bar (NavHeader)
    zIndexMediumHigh: 200,
    zIndexMedium: 100,
    zIndexMenuOverlay: 100, // the same as the zIndexMedium
    zIndexLowerThanMenuOverlay: 99, // zIndexMedium - 1
    zIndexThree: 3,
    zIndexTwo: 2,
    zIndexOne: 1,
    zIndexLow: 0,
    zIndexLowest: -100,
};

export default v;